import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from '@remix-run/react';
import type { LinksFunction } from '@remix-run/node';
import stylesheet from '~/shared/styles/tailwind.css?url';
import SmoothScroll from '~/shared/ui/SmoothScroll/SmoothScroll';
import 'swiper/css/bundle';
import { RemResizeScript } from './features/rem-resize';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { ToastContainer, toast } from 'react-toastify';

import './widgets/CalendarByCss/calendar.scss';
import { WithAuth } from '~/WithAuth';
import { useEffect } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-creative';
import 'swiper/css/effect-cards';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/grid';

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: stylesheet },
  { rel: 'manifest', href: '/manifest.json' },
];
const queryClient = new QueryClient();

export function Layout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/sw.js')
          .then((registration) => {
            console.log(
              'Service Worker registered with scope:',
              registration.scope
            );
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });
      });
    }
  }, []);

  return (
    <html lang="ru">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <Meta />
        <Links />
        <RemResizeScript
          defaultFontSize={10}
          startScaleWidth={1440}
          endScaleTopWidth={2560}
          endScaleBottomWidth={1024}
        />
        <script
          src={`https://api-maps.yandex.ru/v3/?apikey=bcab05a6-54b1-440f-ad20-ab56a61617e8&lang=ru_RU`}></script>
      </head>
      <body>
        <SmoothScroll>
          <div id="app">
            {children}
            {/* <ToastContainer /> */}
            {/* <Toast title={'datadata'} description={'data'} date={'date'} /> */}
          </div>

          <ScrollRestoration />
        </SmoothScroll>
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  const AuthenticatedOutlet = WithAuth(Outlet);
  return (
    <QueryClientProvider client={queryClient}>
      <AuthenticatedOutlet />
    </QueryClientProvider>
  );
}
